import { api } from "./api";

let gaId = null;

const MEASUREMENT_PURPOSE = "4";

export function getConsent() {
  const iubApi = window._iub?.cs?.api;
  if (!iubApi) return null;
  try {
    const purposes = iubApi.getPreferences?.()?.purposes;
    if (purposes && MEASUREMENT_PURPOSE in purposes) return purposes[MEASUREMENT_PURPOSE] ? "accepted" : "rejected";
    if (!iubApi.isPreferenceExpressed?.()) return null;
    return iubApi.isConsentGiven?.() ? "accepted" : "rejected";
  } catch (e) { return null; }
}

function clearGaCookies() {
  document.cookie.split(";").map((c) => c.split("=")[0].trim()).filter((n) => n.startsWith("_ga") || n === "_gid")
    .forEach((n) => {
      const host = window.location.hostname;
      [host, `.${host}`, `.${host.split(".").slice(-2).join(".")}`].forEach((d) => {
        document.cookie = `${n}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${d}`;
      });
      document.cookie = `${n}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    });
}

export async function loadAnalytics() {
  if (getConsent() !== "accepted" || document.getElementById("ga4-script")) return;
  if (!gaId) {
    try { gaId = (await api.get("/public/analytics-config")).data.ga4_measurement_id; } catch (e) { return; }
  }
  if (!gaId || getConsent() !== "accepted") return;
  window[`ga-disable-${gaId}`] = false;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", gaId, { anonymize_ip: true });
  const s = document.createElement("script");
  s.id = "ga4-script";
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(gaId)}`;
  document.head.appendChild(s);
}

function applyConsent(value) {
  if (value === "accepted") {
    loadAnalytics();
  } else {
    if (gaId) window[`ga-disable-${gaId}`] = true;
    document.getElementById("ga4-script")?.remove();
    clearGaCookies();
  }
}

export function watchConsent() {
  let last;
  const check = () => {
    const value = getConsent();
    if (value !== last) { last = value; if (value) applyConsent(value); }
  };
  check();
  const timer = setInterval(check, 1500);
  return () => clearInterval(timer);
}

export function openCookiePreferences() {
  window._iub?.cs?.api?.openPreferences?.();
}
